/*
 * Copyright (c) 2023. All rights are reserved to Newport Collection
 */

import React from "react";
import MetaTitle from "../../meta/title";
import MetaDescription from "../../meta/description";
import MetaImage from "../../meta/image";
import MetaCanonical from "../../meta/canonical";
import MetaUrl from "../../meta/url";
import Head from "next/head";
import { getProductMetaDescription } from '@functions/productOps';
import { useTranslation } from "../../../tools/i18n";
import useSessionStore from '@services/stores/SessionStore';

export default function ProductMeta({product, prices, canonicalPath}) {
	const formatPrice = useSessionStore((state) => state.methods.formatPrice);
	const { t } = useTranslation(['product-info']);

	function getMetaTitle() {
		let title = product.translated.metaTitle || product.translated.name;

		if (title.indexOf('&amp;') > 0) {
			title = title.replace('&amp;', '&');
		}

		return title + ' - Newport';

	}

	function isOldENIEUrl(locale, salesChannel) {
		return locale === 'en-IE' && salesChannel === '5fe6fddfe24e4b358efcac6cda56ea7f';
	}

	function getHrefLangTags() {
		let hrefLangUrls = product?.translated?.customFields?.seoUrls;

		if(hrefLangUrls && hrefLangUrls.length > 0) {
			return hrefLangUrls.filter((seoUrl) => !isOldENIEUrl(seoUrl.locale, seoUrl.salesChannel)).map((seoUrl, key) => {
				let hreflang = seoUrl.locale === 'en-IE' ? 'en' : seoUrl.locale;

				return <link
					rel="alternate"
					hrefLang={hreflang}
					href={seoUrl.url}
					key={'hreflang-link-' + key}
				/>
			});
		}

		return '';
	}

	return (
		<>
			<MetaTitle title={getMetaTitle()}/>
			<MetaDescription description={getProductMetaDescription({product, prices, translation: t, formatPrice})}/>
			<MetaImage image={product.cover ? product.cover.media.url : ''}/>
			<MetaCanonical canonicalPathInfo={canonicalPath} />
			<MetaUrl url={canonicalPath} />
			<Head>
				{getHrefLangTags()}
			</Head>
		</>
	);
}
